const storageKey = 'exam_lang'

function translateLanguageCode(languages, code) {
  let language = languages.find((item) => item.lang === code)

  if (!language) {
    console.info(code + ' language is not found')
    // if exam is single language
    // just select the language
    if (languages.length === 1) {
      language = languages[0]
    } else {
      language = null
    }
  }
  return language
}

export default {
  namespaced: true,

  state: {
    available_languages: null,
    selected_language: null,
  },

  getters: {
    haveMultipleLanguages: (state) => {
      if (state.available_languages.length === 1) {
        return false
      }
      return true
    },

    noLanguageSelected: (state) => {
      let result = true
      state.available_languages.forEach((language) => {
        if (state.selected_language) {
          if (state.selected_language.lang === language.lang) {
            result = false
          }
        }
      })
      return result
    },
  },

  mutations: {
    SET_AVAILABLE_LANGUAGES(state, languages) {
      state.available_languages = languages
    },
    SET_SELECTED_LANGUAGE(state, lang) {
      state.selected_language = lang
    },
  },

  actions: {
    initializeLanguage({ commit }, { exam_language_codes, system_languages }) {
      let available_languages = []
      system_languages.forEach((sys_lang) => {
        exam_language_codes.forEach((exam_lang) => {
          if (sys_lang.lang === exam_lang.lang) {
            available_languages.push(sys_lang)
          }
        })
      })

      let selected_language = translateLanguageCode(available_languages, localStorage.getItem(storageKey))

      if (selected_language) {
        localStorage.setItem(storageKey, selected_language.lang)
        commit('SET_SELECTED_LANGUAGE', selected_language)
      }
      commit('SET_AVAILABLE_LANGUAGES', available_languages)
    },

    changeSelectedLanguage({ commit, state }, lang) {
      let language = translateLanguageCode(state.available_languages, lang)
      if (language) {
        localStorage.setItem(storageKey, lang)
        commit('SET_SELECTED_LANGUAGE', language)
      }
    },

    // when user is in the middle of exam, only one language code is send
    // from backend to front as exam language and that is the instance language
    // and user have not choice and that language should be committed as  selected language
    // and also only one available language exists and its the same as exam language
    initMiddleOfExam({ commit }, { exam_language_code, system_languages }) {
      let available_languages = []
      system_languages.forEach((sys_lang) => {
        if (sys_lang.lang === exam_language_code) {
          available_languages.push(sys_lang)
        }
      })

      commit('SET_AVAILABLE_LANGUAGES', available_languages)
      let selected_language = translateLanguageCode(available_languages, exam_language_code)
      if (selected_language) {
        commit('SET_SELECTED_LANGUAGE', selected_language)
        // if user changes his device in the  middle of an exam,
        // the exam language code is stored in user's browser
        // now if user starts another exam from this new device
        // the default selected language is the language of the last exam he took
        localStorage.setItem(storageKey, selected_language.lang)
      }
    },
  },
}
